export class FormulaDTO {
    public Id:number;
    public Codigo:string;
    public Descripcion:string;
    public XMLValue:string;
    public CShapValue:string;
    public FormulaType:string;
    public CodNomina:number;
    public StringValue:string;
    public StringFormat:string;
}
